// Category drawer. Slide-out panel with one level of nested views.
//
// Uses event delegation on the host element rather than binding to children,
// so it works no matter when the browser finishes parsing them.
if (!customElements.get('tk-cat-drawer')) {
  customElements.define(
    'tk-cat-drawer',
    class extends HTMLElement {
      connectedCallback() {
        this.trigger = null;
        this.onKey = this.onKey.bind(this);

        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-close]')) return this.close();

          const opener = e.target.closest('[data-open-view]');
          if (opener) return this.show(opener.dataset.openView);

          if (e.target.closest('[data-back]')) return this.show('root');
        });

        // Triggers live outside this element, so they're bound on document.
        document.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-tk-catd-trigger]');
          if (!btn) return;
          e.preventDefault();
          this.open(btn);
        });
      }

      get views() {
        return Array.from(this.querySelectorAll('[data-level]'));
      }

      open(trigger) {
        this.trigger = trigger || null;
        this.dataset.open = 'true';
        document.body.classList.add('tk-catd-lock');
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
        document.addEventListener('keydown', this.onKey);
        this.show('root');

        const first = this.querySelector('.tk-catd__panel button, .tk-catd__panel a');
        if (first) first.focus({ preventScroll: true });
      }

      close() {
        this.dataset.open = 'false';
        document.body.classList.remove('tk-catd-lock');
        document.removeEventListener('keydown', this.onKey);
        if (this.trigger) {
          this.trigger.setAttribute('aria-expanded', 'false');
          this.trigger.focus({ preventScroll: true });
        }
      }

      onKey(e) {
        if (e.key === 'Escape') this.close();
      }

      show(name) {
        const views = this.views;
        views.forEach((view) => {
          const isTarget = view.dataset.view === name;
          const isRoot = view.dataset.level === '0';
          view.dataset.active = String(isTarget);
          // The root slides partly out of frame when a child view is showing.
          view.dataset.behind = String(isRoot && name !== 'root');
        });

        const active = views.find((v) => v.dataset.view === name);
        if (active) {
          active.scrollTop = 0;
          if (name !== 'root') {
            const focusable = active.querySelector('button, a');
            if (focusable) focusable.focus({ preventScroll: true });
          }
        }
      }
    }
  );
}